import { render } from "./toast.vue?vue&type=template&id=df0a245c&ts=true"
import script from "./toast.vue?vue&type=script&lang=ts"
export * from "./toast.vue?vue&type=script&lang=ts"

import "./toast.vue?vue&type=style&index=0&id=df0a245c&lang=less"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__